import { GLOBAL_CONSTANTS } from 'assets/js/utils/constants.js'

class AudioPlayerBlock {
  constructor (element) {
    this.element = element
    this.emitter = GLOBAL_CONSTANTS.UTILS.EMITTER
    this.registerEvents()
  }

  registerEvents() {
    this.emitter.on(GLOBAL_CONSTANTS.EVENTS.AUDIO_TRANSCRIPT_TOGGLE, ({ element, isVisible }) => {
      if (this.element.contains(element)) {
        this.element.classList.toggle('-transcript')
      }
    })
  }
}

export default {
  selector: '.js-audio-block',
  Source: AudioPlayerBlock
}
